module.exports = __webpack_public_path__ + "static/media/accessories.cad7870f.png";